import request from '../util/request'

//隐私协议
/*export function xieyi(params) {
    return request({
        method:'GET',
        url: '/auth/login',
        params: params
    })
}*/


//获取验证码
export function sendsms(data) {
    return request({
        method:'POST',
        url: '/api/common/sendsms',
        data: data
    })
}
//注册
export function register(data) {
    return request({
        method:'POST',
        url: '/api/user/register',
        data: data
    })
}
